/**
 * Phase 2c-2 — the visible approval-state badge carried by every
 * generated / Copilot-touched artifact. "AI-drafted" is the born state; the
 * badge advances through in_review → approved (or rejected) as a human drives
 * the asset. Copilot-produced drafts get a tooltip making the "needs human
 * approval" rule explicit (vision §12).
 */ import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
const STATE_META = {
    ai_drafted: {
        label: 'AI-drafted',
        variant: 'secondary'
    },
    in_review: {
        label: 'In review',
        variant: 'outline'
    },
    approved: {
        label: 'Approved',
        variant: 'default'
    },
    rejected: {
        label: 'Rejected',
        variant: 'destructive'
    }
};
export function AiDraftedBadge({ state, generatedBy }) {
    const meta = STATE_META[state] ?? {
        label: state,
        variant: 'secondary'
    };
    const title = state === 'approved' ? 'Approved by a human — cleared for official use' : generatedBy === 'copilot' ? 'Drafted by Copilot — needs human approval before it can be marked official' : 'AI-generated draft — needs human approval before it can be marked official';
    return /*#__PURE__*/ _jsx(Badge, {
        variant: meta.variant,
        title: title,
        "data-testid": Testids.artifactStudio.aiDraftedBadge,
        children: meta.label
    });
}
